import { useState, useEffect } from "react"
import { useLanguage } from "../../contexts/LanguageContext";

const inputStyle = {
  width: '100%', padding: '10px 14px', background: 'var(--bg-elevated)', border: '1px solid var(--border-subtle)',
  borderRadius: '10px', color: 'var(--text-primary)', fontSize: '0.9rem', outline: 'none', marginTop: '4px',
};

export default function AdModal({ ad, onClose, onSubmit }) {
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const { t } = useLanguage();

  useEffect(() => {
    if (ad) { setTitle(ad.title); setDescription(ad.description); }
  }, [ad])

  const handleSubmit = () => {
    if (title && description) {
      ad ? onSubmit(ad.id, title, description) : onSubmit(title, description);
      setTitle(""); setDescription("");
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px', zIndex: 50 }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-glass)', borderRadius: '20px', padding: '28px', width: '400px', maxWidth: '90vw', position: 'relative' }}>
        <div style={{ height: '3px', position: 'absolute', top: 0, left: 0, right: 0, borderRadius: '20px 20px 0 0', background: 'linear-gradient(90deg, var(--accent-cyan), var(--accent-violet))' }} />
        <div style={{ textAlign: 'center', marginTop: '8px' }}>
          <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)', marginBottom: '16px' }}>
            {ad ? t('editAdvertisement') : t('addNewAdvertisement')}
          </h3>
          <form id="adForm" style={{ textAlign: 'left' }}>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)' }}>{t('title')}</label>
              <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required style={inputStyle}
                onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)' }}>{t('description')}</label>
              <textarea rows="3" value={description} onChange={(e) => setDescription(e.target.value)} required
                style={{ ...inputStyle, resize: 'vertical' }}
                onFocus={e => e.target.style.borderColor = 'var(--accent-cyan)'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
            </div>
          </form>
          <div style={{ display: 'grid', gap: '8px', marginTop: '8px' }}>
            <button onClick={onClose} style={{ padding: '12px', borderRadius: '12px', border: '1px solid var(--border-glass)', background: 'var(--bg-elevated)', color: 'var(--text-secondary)', fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem' }}>{t('close')}</button>
            <button onClick={handleSubmit} style={{ padding: '12px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem' }}>{t('submit')}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

